import React, { createContext, useContext } from 'react';

const AccessibilityContext = createContext({ reducedMotion: false });

export function AccessibilityProvider({ children }: { children: React.ReactNode }) {
  return (
    <AccessibilityContext.Provider value={{ reducedMotion: false }}>
      {children}
    </AccessibilityContext.Provider>
  );
}

export function useAccessibility() {
  return useContext(AccessibilityContext);
}
